import type { Form } from '@balance-web/forms';
import { field, validate } from '@balance-web/forms';

export const SignInFormSchema = field.object({
  emailOrUsername: field.text({
    validate: validate((value) => {
      validate.required(value);
      if (value.includes('@')) {
        validate.email(value);
      }
      return value;
    }),
  }),
  password: field.text({
    validate: validate((value) => {
      validate.required(value);
      return value;
    }),
  }),
});

export type SignInFormInstance = Form<typeof SignInFormSchema>;
